<template>
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        </b-col>
        <b-col cols="12" class="justify-content-between mt-2">
            <template v-if="!job_offer">
                You don't have the active Job Offers
            </template>
            <template>
                <div class="d-flex align-items-center mt-2 w-100">
                    <b-col cols="12" md="12" class="p-1 p-md-2">
                        <div class="h-100  p-1 p-md-2 p-xl-3">
                            <div v-if="job_information">
                                <b-row v-if="job_information.company_name" class="my-2">
                                    <b-col md="5">
                                    <span class="font-weight-bold">Job Opportunity Name: </span>
                                    </b-col>
                                    <b-col md="7"> {{ job_information.company_name }} </b-col>
                                </b-row>
                                <b-row v-if="job_information.title" class="my-2">
                                    <b-col md="5">
                                    <span class="font-weight-bold">Job Title: </span>
                                    </b-col>
                                    <b-col md="7"> {{ job_information.title }} </b-col>
                                </b-row>
                                <b-row v-if="job_information.title" class="my-2">
                                    <b-col md="5">
                                    <span class="font-weight-bold">Facility: </span>
                                    </b-col>
                                    <b-col md="7"> {{ job_information.practice_name }} </b-col>
                                </b-row>
                                <b-row v-if="job_information.description" class="my-2">
                                    <b-col md="5">
                                        <span class="font-weight-bold">Job Description: </span>
                                    </b-col>
                                    <b-col md="7">
                                        {{ job_information.description }}
                                    </b-col>
                                </b-row>
                                <b-row v-if="job_information.welcome_message" class="my-2">
                                    <b-col md="5">
                                        <span class="font-weight-bold">Welcome Message: </span>
                                    </b-col>
                                    <b-col md="7">  {{ job_information.welcome_message }}  </b-col>
                                </b-row>
                                <b-row v-if="job_information.external_url" class="my-2">
                                    <b-col md="5">
                                        <span class="font-weight-bold">Job Board URL: </span>
                                    </b-col>
                                    <b-col md="7">                               
                                        <a :href="job_information.external_url" target="_blank">{{ job_information.external_url }}</a>
                                    </b-col>
                                </b-row>
                                <b-row v-if="job_information.tracking_num" class="my-2">
                                    <b-col md="5">
                                        <span class="font-weight-bold">PO# or Tracking #: </span>
                                    </b-col>
                                    <b-col md="7">  {{ job_information.tracking_num }}  </b-col>
                                </b-row>
                                 <b-row class="my-2">
                                    <b-col sm="12" md="12" lg="12">
                                    <recruiter-review-ico-criteria-results
                                        :criteria-items=this.$store.state.job_offer
                                    />
                                    </b-col>
                                </b-row>  
                            </div>  
                            <b-row class="m-0">
                                <b-col cols="12" md="12" class="p-1">
                                    <div class1="h-100 p-1 p-md-2 p-xl-3">
                                        <span class="font-weight-bold">Customer Information</span>

                                        <b-row v-if="user.profile.company_name" class="my-2">
                                            <b-col md="5">
                                                <span class="font-weight-bold">Company Name: </span>
                                            </b-col>
                                            <b-col md="7"> {{ user.profile.company_name }} </b-col>
                                        </b-row>

                                        <b-row v-if="user.first_name" class="my-2">
                                            <b-col md="5">
                                                <span class="font-weight-bold">Contact Name: </span>
                                            </b-col>
                                            <b-col md="7"> {{ user.first_name }} {{ user.last_name }}</b-col>
                                        </b-row>

                                        <b-row v-if="user.email" class="my-2">
                                            <b-col md="5">
                                                <span class="font-weight-bold">Contact Email: </span>
                                            </b-col>
                                            <b-col md="7"> {{ user.email }} </b-col>
                                        </b-row>

                                        <b-row v-if="user.profile.phone_number" class="my-2">
                                            <b-col md="5">
                                                <span class="font-weight-bold">Contact Phone: </span>
                                            </b-col>
                                            <b-col md="7"> {{ user.profile.phone_number }} </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </div>
                <b-col cols="12" class="d-flex justify-content-between mt-2">
                    <b-form-row class="justify-content-center w-100-per">
                        <b-row>
                            <b-col cols="6" class="text-right mt-3">
                                <b-button
                                type="submit"
                                class="btn btn-next"
                                @click="changePropValue('Back')"
                                >
                                <i class="mdi mdi-arrow-left-bold ml-1 pr-1"></i> Back
                                </b-button>
                            </b-col>
                            <b-col cols="6" class="d-flex justify-content-right mt-3">
                                <b-button v-if="this.$store.state.set_job_information==false"
                                type="submit"
                                class="btn btn-next"
                                :job-offer="jobOffer"
                                @click="changePropValue('Next')"
                                >
                                Next <i class="mdi mdi-arrow-right-bold ml-1"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form-row>
                </b-col>
                <b-col cols="12" class="d-flex justify-content-between mt-2">
                    <b-form-row class="justify-content-center w-100-per">
                        <b-row>
                            <b-col cols="6" class="text-right">
                                <b-button
                                type="submit"
                                class="btn btn-next"
                                @click="gotoICO"
                                >
                                Cancel
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form-row>
                </b-col>
            </template>
        </b-col>
    </b-row>
</template>
<script>
//import RecruiterReviewJobCriteriaResult from '@/components/recruiter/ico/criteria/result/RecruiterReviewJobCriteriaResult';
import RecruiterReviewIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterReviewIcoCriteriaResults';

export default {
    name: 'RecruiterReviewJobOpportunityDetails',
    components: {
        RecruiterReviewIcoCriteriaResults
  },
    data: function () {
        return {
        jobOffer: null,
        jobInformation: null,
        isLoading: false,
        };
    },
    created: function () {
        this.$store.state.set_job_information = false;
    },
    computed: {
        user: function () {
            return this.$store.state.user;
        },
        job_offer: function () {
            this.jobOffer = this.$store.state.job_offer;
            return this.$store.state.job_offer;
        },
        job_information: function () {
            return (this.$store.state.job_information ? this.$store.state.job_information : null);
        },
        specialty: function () {
            if (!this.$store.state.offer_specialty.specialtyId)
                return null;
            return (
                this.$store.state.specialtyOptions.find(
                (s) => s.value === this.$store.state.offer_specialty.specialtyId
                ) || {}
            ).specialty;        
        },
        specialtyName: function () {
            return (this.specialty || {}).title;
        },
        subspecialty: function () {
            if (!this.$store.state.offer_specialty.subspecialtyId)
                return null;
            return (
                this.$store.state.subspecialtyOptions.find(
                (s) => s.value === this.$store.state.offer_specialty.subspecialtyId
                ) || {}
            ).subspecialty;
        },
        subspecialtyName: function () {
        return (this.subspecialty || {}).title;
        },
    },
    methods: {
        changePropValue(label) {
            // Emit an event to notify the parent component of the change
            if (label === 'Next') {
                this.$emit('updatePropValue', 4);
            }
            else if (label === 'Back') {
                this.$store.state.set_job_information = false;
                // Do something for the "Back" button
                this.$emit('updatePropValue', 1);
            }
        },
        gotoICO: function(){
            this.$store.state.job_offer=undefined;
            this.$store.state.is_change_criteria=undefined;
            this.$store.state.is_new_offer=undefined;
            this.$store.state.location_zip_code=undefined;
            this.$store.state.set_job_information = undefined;
            this.$store.state.specialtyId = undefined;
            this.$store.state.isComeFromIco = undefined;
            this.$store.state.is_change_criteria=undefined;
            this.$router.go(0);   
        }
    },
}
</script>
<style scoped>
@media (max-width:768px){
    .btn-next{
        padding-left: 1rem !important;
        padding-right: 1rem !important;
    }
}

.justify-content-center{
    justify-content: center;
}
.w-100-per{
    width: 100%; 
}
.btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #99c555 !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  padding-left: 3rem;
  padding-right: 3rem;
}
.btn-next:hover{
  background-color: #b0d27b !important;
}
.btn-next i{
  font-size:15px;
}
</style>